import { WHATSAPP_NUMBER, ALL_ITEMS, MOMENTS, STYLE_GROUPS } from "@/config/pricing";

// Indonesian Rupiah formatting -> "Rp 1.500.000"
export const formatRupiah = (value) => {
  const n = Number(value) || 0;
  return "Rp " + n.toLocaleString("id-ID");
};

// Human readable event type from selected moment ids.
export const eventTypeFromMoments = (momentIds) => {
  if (!momentIds || momentIds.length === 0) return "";
  return MOMENTS.filter((m) => momentIds.includes(m.id))
    .map((m) => m.label)
    .join(" + ");
};

// Group selected item ids by category for the summary panel.
export const groupSelected = (selectedIds) => {
  const groups = {};
  selectedIds.forEach((id) => {
    const item = ALL_ITEMS[id];
    if (!item) return;
    if (!groups[item.category]) groups[item.category] = [];
    groups[item.category].push(item);
  });
  return groups;
};

// Gaya video yang dipilih untuk sebuah layanan (atau null).
export const styleOf = (itemId, styleId) => {
  const item = ALL_ITEMS[itemId];
  if (!item || !item.styleGroup || !styleId) return null;
  return (STYLE_GROUPS[item.styleGroup] || []).find((s) => s.id === styleId) || null;
};

export const computeTotal = (selectedIds) =>
  selectedIds.reduce((sum, id) => sum + (ALL_ITEMS[id]?.price || 0), 0);

// Build a nicely formatted WhatsApp message and return the wa.me link.
export const buildWhatsAppLink = ({ selectedIds, form, total, styles = {} }) => {
  const lines = selectedIds
    .map((id) => ALL_ITEMS[id])
    .filter(Boolean)
    .map((item) => {
      const st = styleOf(item.id, styles[item.id]);
      return `${item.name} — ${formatRupiah(item.price)}${st ? `\n   Gaya video: ${st.name}` : ""}`;
    })
    .join("\n");

  const message = `Halo DIRGA,

Saya ingin request paket wedding photography/videography.

Nama:
${form.fullName || "-"}

Tanggal Acara:
${form.eventDate || "-"}

Lokasi:
${form.eventLocation || "-"}

Jenis Acara:
${form.eventType || "-"}

Layanan yang Dipilih:
${lines || "-"}

Estimasi Biaya:
${formatRupiah(total)}

Instagram:
${form.instagram || "-"}

WhatsApp:
${form.whatsapp || "-"}

Catatan Tambahan:
${form.notes || "-"}

Terima kasih.`;

  const base = WHATSAPP_NUMBER
    ? `https://wa.me/${WHATSAPP_NUMBER}`
    : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(message)}`;
};
